import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import React, { useEffect, useState } from "react";
// import PayInOutGraph from "../../../../asset/images/payin-and-payout.svg";
// import DropdownFilter from "../../../Common/DropdownFilter";
import Form from "react-bootstrap/Form";
import { DASHBOARD_CLIENT_DETAIL_EQUITY } from "../../../Configuration/API_URL";
import {
  AESEncryption,
  ApiResDecrypt,
  decryptData,
  noDataFound,
  splitDate,
  splitDateNew,
} from "../../../CommonMethhods/CommonMethods";
import { Constants } from "../../../CommonMethhods/Constants";
// import PayinDetailsTable from "./PayinDetailsTable";
// import PayoutDetailsTable from "./PayoutDetailsTable";
import { numDifferentiation } from "../../../CommonMethhods/CovertRupees";
import { toast } from "react-toastify";
import Loader from "../../../Components/Common/Loader";
import SmallLoader from "../../../Components/Common/smallLoader";
import { partner_Api } from "../../../Configuration/Partner_URL";
import { axiosSsoJsonReserv1 } from "../../../CommonMethhods/axiosPartnerInterceptor";

function PartnerPayinPayout() {
  const PartnerClientCode = localStorage.getItem("ClientId2");
  // const clientCode = localStorage.getItem("clientCode");
  const storeToken = localStorage.getItem("ssoToken");
  const [payInData, setPayInData] = useState([]);
  const [payInDetail, setPayInDetail] = useState([]);
  const [payOutDetail, setPayOutDetail] = useState([]);
  const [checkTable, setCheckTable] = useState("payin");
  const [payIn, setPayIn] = useState();
  const [payOut, setPayOut] = useState();
  const [month, setMonth] = useState();
  const [average, setAverage] = useState();
  const [filterBy, setFilterBy] = useState("month");
  const [error, setError] = useState();
  const [loader, setLoader] = useState(true);
  const [serverError, setServerError] = useState("");
  const [payoutServer, setPayoutServer] = useState("");
  const [graphServerError, setGraphServerError] = useState("");
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [fileType, setFileType] = useState("grid");

  const colors = ["#007bff", "#0dbf8d", "#ff86b1"];
  const payInPayOut = {
    credits: {
      enabled: false,
    },
    // chart: {v
    //   type: "bar",
    // },
    title: {
      text: null,
    },
    xAxis: {
      categories: month,
      title: {
        text: null,
      },
    },
    yAxis: {
      min: 0,
      gridLineWidth: 0,
      title: {
        text: null,
        align: "high",
      },

      labels: {
        enabled: true,
        overflow: "justify",
      },

      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
          },
        },
      },
    },
    tooltip: {
      pointFormat: `{series.name}: <b>{point.y:.2f}</b>`,
    },

    // tooltip: {
    //   enabled: false,
    // },

    series: [
      {
        color: colors[2],
        type: "column",
        name: "Payin",
        data: payIn ? payIn : [],
      },
      {
        color: colors[0],
        type: "column",
        name: "Payout",
        data: payOut ? payOut : [],
        // data: [24, 79, 72, 240, 167]
      },
      // {
      //   color: colors[1],
      //   type: "spline",
      //   name: "Average",
      //   data: average ? average : [],
      // },
    ],
  };

  const payinDetailTable = async (clientCode, type) => {
    if (fileType == "excel") {
      setSmallLoaderExcel(true);
      setSmallLoaderPdf(false);
    }
    if (fileType == "pdf") {
      setSmallLoaderPdf(true);
      setSmallLoaderExcel(false);
    }
    let payloadValue = { ClientCode: clientCode, type: type };
    let encPayload = AESEncryption(payloadValue);
    // setLoader(true);
    try {
      const getPayinData = await axiosSsoJsonReserv1.post(
        DASHBOARD_CLIENT_DETAIL_EQUITY.PayinDetails_URL,

        `"${encPayload}"`,
      );
      const payinRespData = ApiResDecrypt(getPayinData?.data);
      // let decryptedResp = JSON.parse(payinRespData);

      if (payinRespData?.data) {
        if (type == "grid") {
          setPayInDetail(payinRespData?.data);
        } else if (type == "excel") {
          window.open(payinRespData?.data, "_self", "noopener,noreferrer");
        } else if (type == "pdf") {
          window.open(payinRespData?.data, "_blank", "noopener,noreferrer");
        }
      } else {
        setPayInDetail([]);
        if (type == "excel") {
          toast.error("Paying detail does not exist.");
        } else if (type == "pdf") {
          toast.error("Paying detail does not exist.");
        }
      }

      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setServerError("Something went wrong, Please try again later.");
      if (type == "excel") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (type == "pdf") {
        toast.error("Something went wrong, Please try again later.");
      }
    }
  };

  const payoutDetailTable = async (clientCode, type) => {
    if (type == "excel") {
      setSmallLoaderExcel(true);
      setSmallLoaderPdf(false);
    }
    if (type == "pdf") {
      setSmallLoaderPdf(true);
      setSmallLoaderExcel(false);
    }
    // setLoader(true);
    let payloadValue = { ClientCode: clientCode, type: type };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getPayoutData = await axiosSsoJsonReserv1.post(
        DASHBOARD_CLIENT_DETAIL_EQUITY.PayoutDetails_URL,
        `"${encPayload}"`,
      );
      const payoutRespData = ApiResDecrypt(getPayoutData?.data);
      // let decryptedPayout = JSON.parse(payoutRespData);
      if (payoutRespData?.data) {
        if (type == "grid") {
          setPayOutDetail(payoutRespData?.data);
        } else if (type == "excel") {
          window.open(payoutRespData?.data, "_self", "noopener,noreferrer");
        } else if (type == "pdf") {
          window.open(payoutRespData?.data, "_blank", "noopener,noreferrer");
        }
      } else {
        setPayOutDetail([]);
        if (type == "excel") {
          toast.error("Payout detail does not exist.");
        } else if (type == "pdf") {
          toast.error("Payout detail does not exist.");
        }
      }
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setPayoutServer("Something went wrong, Please try again later.");
      if (type == "excel") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (type == "pdf") {
        toast.error("Something went wrong, Please try again later.");
      }
    }
  };

  const payinPayoutChart = async (clientCode) => {
    setLoader(true);
    let payloadValue = { ClientCode: clientCode, Duration: filterBy };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getData = await axiosSsoJsonReserv1.post(
        DASHBOARD_CLIENT_DETAIL_EQUITY.PayinPayout_URL,
        `"${encPayload}"`,
      );
      const responseData = ApiResDecrypt(getData?.data);
      // let decryptedRespData = JSON.parse(responseData);
      setPayInData(responseData?.data);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
      setGraphServerError("Something went wrong, Please try again later.");
    }
  };
  const chartData = () => {
    const payin = [];
    const payout = [];
    const month = [];
    const average = [];
    if (payInData?.length > 0) {
      payInData.map((item) => {
        payin.push(item.payin);
        payout.push(item.payout);
        month.push(item.month_year);
        average.push(item.payin + item.payout / 2);
      });
      setPayIn(payin);
      setPayOut(payout);
      setMonth(month);
      setAverage(average);
    } else {
      setError("No Data available");
    }
  };
  const handleOnChange = (e) => {
    setFilterBy(e.target.value);
    setFileType("");
  };

  useEffect(() => {
    
    if (PartnerClientCode) {
      payinPayoutChart(PartnerClientCode);
    } else {
      setLoader(false);
    }
    // }
  }, [filterBy]);

  useEffect(() => {
    payinDetailTable(PartnerClientCode, "grid");
  }, []);

  useEffect(() => {
    chartData();
  }, [payInData]);

  const handleViewTable = (e) => {
    if (e.target.value) {
      setCheckTable(e.target.value);
      if (e.target.value == "payin") {
        payinDetailTable(PartnerClientCode, "grid");
      } else {
        payoutDetailTable(PartnerClientCode, "grid");
      }
    }
  };

  const selectOption = (e) => {
    if (checkTable == "payin") {
      if (e.target.value) {
        setFileType(e.target.value);
        payinDetailTable(PartnerClientCode, e.target.value);
      }
    } else {
      if (e.target.value) {
        setFileType(e.target.value);
        payoutDetailTable(PartnerClientCode, e.target.value);
      }
    }
  };

  const showPayinDetail = (payInDetail) => {
    return (
      payInDetail?.length > 0 &&
      payInDetail.map((info, key) => {
        return (
          <tr>
            <td scope="col">
              {info?.date_Time == "" || undefined || null
                ? "-"
                : splitDateNew(info?.date_Time)}
            </td>
            <td scope="col">
              {info?.amount == "" || undefined || null
                ? "-"
                : numDifferentiation(info?.amount)}
            </td>
            <td scope="col">
              {info?.status == "" || undefined || null ? "-" : info?.status}
            </td>
            <td scope="col">
              {info?.paymentMode == "" || undefined || null
                ? "-"
                : info?.paymentMode}
            </td>
            <td scope="col">
              {info?.account == "" || undefined || null ? "-" : info?.account}
            </td>
            <td scope="col">
              {info?.transactionId == "" || undefined || null
                ? "-"
                : info?.transactionId}
            </td>
          </tr>
        );
      })
    );
  };

  const showPayoutDetail = (payOutDetail) => {
    return (
      payOutDetail?.length > 0 &&
      payOutDetail.map((info, key) => {
        return (
          <tr>
            <td scope="col">
              {info?.requestDate == "" || undefined || null
                ? "-"
                : splitDateNew(info?.requestDate)}
            </td>
            <td scope="col">
              {info?.approveAmt == "" || undefined || null
                ? "-"
                : numDifferentiation(info?.approveAmt)}
            </td>
            <td scope="col">
              {info?.status == "" || undefined || null ? "-" : info?.status}
            </td>
            <td scope="col">
              {info?.bankName == "" || undefined || null ? "-" : info?.bankName}
            </td>
            <td scope="col">
              {info?.bankAccount == "" || undefined || null
                ? "-"
                : info?.bankAccount}
            </td>
            <td scope="col">
              {info?.merRefNo == "" || undefined || null ? "-" : info?.merRefNo}
            </td>
          </tr>
        );
      })
    );
  };

  return (
    <>
      <div className="col-12 col-md-12 pay-in-card">
        <div className="card-box graph">
          <div className="card-title">
            <div className="figure-inlac">
              <h2 className="small-title">{Constants.Payin_Payout_Details}</h2>
              {/* <p>{Constants.Figure_In_Lacs_for_all}</p> */}
            </div>

            <div className="filter-options">
              {/* <!-- dropdown --> */}
              <ul
                className="nav nav-tabs filter-tabs"
                id="knowledgeTab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="video-tab"
                    data-toggle="tab"
                    data-target="#video-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="video-tab-pane"
                    aria-selected="false"
                  >
                    {Constants.Details}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link "
                    id="module-tab"
                    data-toggle="tab"
                    data-target="#module-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="module-tab-pane"
                    aria-selected="true"
                  >
                    {Constants.Summary_Client}
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div
            className="tab-content refer-tab-content"
            id="knowledgeTabContent"
          >
            <div
              className="tab-pane fade  show active"
              id="video-tab-pane"
              role="tabpanel"
              aria-labelledby="video-tab"
              tabIndex={0}
            >
              {/* <form onChange={handleOnChange}> */}
              <div className="payin-radio">
                <form>
                  <input
                    type="radio"
                    id="html"
                    name="fav_language"
                    value="payin"
                    defaultChecked="checked"
                    onChange={handleViewTable}
                  />
                  <h4>{Constants.Payin_Detail}</h4>
                  <input
                    type="radio"
                    id="html1"
                    name="fav_language"
                    value="payout"
                    onChange={handleViewTable}
                  />
                  <h4>{Constants.Payout_Detail}</h4>
                </form>
                <div className="paying-payout-btn">
                  <button
                    className="generate-button excel-btn"
                    value="excel"
                    onClick={selectOption}
                  >
                    {smallLoaderExcel ? (
                      // <div>
                      <SmallLoader />
                    ) : (
                      <>
                        <span className="icon-excelsvg"></span>
                        {Constants.Excel}
                      </>
                    )}
                  </button>
                  <button
                    className="generate-button pdf-btn"
                    value="pdf"
                    onClick={selectOption}
                  >
                    {smallLoaderPdf ? (
                      <div>
                        <SmallLoader />
                      </div>
                    ) : (
                      <>
                        <span className="icon-pdfsvg"></span>
                        {Constants.PDF}
                      </>
                    )}
                  </button>
                </div>
              </div>
              {loader ? (
                <div className="loader-alignment">
                  <Loader />
                </div>
              ) : (
                <div className="table-responsive scroll-table report-table-wrapper">
                  {checkTable == "payin" ? (
                    payInDetail && payInDetail?.length > 0 ? (
                      <table className="table">
                        {/* <PayinDetailsTable /> */}
                        <tbody>{showPayinDetail(payInDetail)}</tbody>
                      </table>
                    ) : serverError ===
                      "Something went wrong, Please try again later." ? (
                      <h4 className="no-data">{serverError}</h4>
                    ) : (
                      noDataFound()
                    )
                  ) : payOutDetail && payOutDetail?.length > 0 ? (
                    <table className="table">
                      {/* <PayoutDetailsTable /> */}
                      <tbody>{showPayoutDetail(payOutDetail)}</tbody>
                    </table>
                  ) : payoutServer ===
                    "Something went wrong, Please try again later." ? (
                    <h4 className="no-data">{payoutServer}</h4>
                  ) : (
                    noDataFound()
                  )}
                </div>
              )}
            </div>
            <div
              className="tab-pane fade"
              id="module-tab-pane"
              role="tabpanel"
              aria-labelledby="module-tab"
              tabIndex={0}
            >
              <div className="dropdown-filter">
                {/* <DropdownFilter /> */}
                <Form.Select
                  size="lg"
                  aria-label="Default select example"
                  onChange={handleOnChange}
                >
                  <option value="month">{Constants.Monthly}</option>
                  <option value="quarter">{Constants.Quarterly}</option>
                  <option value="year">{Constants.Yearly}</option>
                </Form.Select>
              </div>
              {loader ? (
                <div className="loader-alignment">
                  <Loader />
                </div>
              ) : (
                <div className="section-graph3">
                  {/* <img
              className="graph-100"
              src={PayInOutGraph}
              alt="payin payoutgraph"
            /> */}
                  {payInData?.length > 0 ? (
                    <HighchartsReact
                      highcharts={Highcharts}
                      options={payInPayOut}
                    />
                  ) : graphServerError ===
                    "Something went wrong, Please try again later." ? (
                    <h4 className="no-data">{graphServerError}</h4>
                  ) : (
                    noDataFound()
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PartnerPayinPayout;
